<app-header [background]="true" ></app-header>
<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>
<section class="mainSection" *ngIf="areaData">
    <div class="container">
        <div class="iconArea">
            <i id="iconElement" class="fa-solid {{areaData.icon}}"></i>
        </div>
        <h2 class="titleArea">{{ areaData.name }}</h2>
        <div class="row">
            <div class="col-lg-6 col-xl-8 col-xxl-9">
                <div class="row indicators">
                    <div class="col-xl-12 mt-3">
                        <p class="descriptionArea" *ngIf="areaData.description !== areaData.name">
                            {{areaData.description}}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-xl-4 col-xxl-3 text-center ">
                <div class="card CardAreas custom-shadow">
                    <div class="card-body">
                        <h4 class="card-title mb-4">{{areaData.modelNameInPlural}}</h4>
                        <ul class="menuLateral mb-0" >
                            <ng-container *ngFor="let eixo of getOrganizersKey()" >
                                <div class="border-with-text mt-3 mb-3" *ngIf="eixo.length > 0">
                                    <span>{{eixo == '' ? '' : eixo}}</span>
                                </div>
                                <li class="nav-item" *ngFor="let area of allAreas[eixo]; let i = index; let last = last" 
                                [ngClass]="{'active': areaId == area.id, 'no-border': last }">
                                    <a class="nav-link d-flex" (click)="replaceIcon(area.icon)"  [routerLink]="['/area']" [queryParams]="{id:area.id}" >
                                        <div class="iconAreaMenu">
                                            <i class="fa-solid {{area.icon}}"></i>
                                        </div>
                                        <div class="textAreaMenu">
                                            {{area.name}}
                                        </div> 
                                    </a>
                                </li>
                            </ng-container>
                        </ul>
                        
                    </div>
                </div>
            </div>
        </div>
        &nbsp;
    </div>
</section>
<section class="secondarySection" style="" *ngIf="areaData">
    <div class="container" style="position: relative ;margin-top: 10rem;">
        <h1 class="titleDesafios">DESAFIOS ESTRATÉGICOS</h1>
        <p class="titleSecondary">Confira os resultados dos indicadores da área de {{areaData.name}} para cada desafio.</p>
        <div class="row">
            <div class="col-lg-4 p-3">
                <div class="card shadow p-3">
                    <div class="card-title">
                        <div class="titleChallenge" >
                            <span class="numberChallenge">{{areaData.challenge.length}}</span>
                            <span class="textChallenge">{{areaData.challenge.length <= 1 ? 'Desafio' : 'Desafios'}}</span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card bg-overview">
                            <h3 class="titleOverview" >{{areaData.startOfAdministrationYear}}</h3>
                            <div class="overview mb-3">
                                <span class="ball-item green-ball-img">{{ countFirstYear.green }}</span>
                                <span class="ball-item yellow-ball-img">{{ countFirstYear.yellow }}</span>
                                <span class="ball-item red-ball-img">{{ countFirstYear.red }}</span>
                                <span class="ball-item gray-ball-img">{{ countFirstYear.gray }}</span>
                            </div>
                        </div>
                        <div class="card bg-overview mt-3">
                            <h3 class="titleOverview" >{{areaData.startOfAdministrationYear + 1}}</h3>
                            <div class="overview mb-3">
                                <span class="ball-item green-ball-img">{{ countSecondYear.green }}</span>
                                <span class="ball-item yellow-ball-img">{{ countSecondYear.yellow }}</span>
                                <span class="ball-item red-ball-img">{{ countSecondYear.red }}</span>
                                <span class="ball-item gray-ball-img">{{ countSecondYear.gray }}</span>
                            </div>
                        </div>
                        <div class="card bg-overview mt-3">
                            <h3 class="titleOverview" >{{areaData.startOfAdministrationYear + 2}}</h3>
                            <div class="overview mb-3">
                                <span class="ball-item green-ball-img">{{ countThirdYear.green }}</span>
                                <span class="ball-item yellow-ball-img">{{ countThirdYear.yellow }}</span>
                                <span class="ball-item red-ball-img">{{ countThirdYear.red }}</span>
                                <span class="ball-item gray-ball-img">{{ countThirdYear.gray }}</span>
                            </div>
                        </div>
                        <div class="card bg-overview mt-3">
                            <h3 class="titleOverview" >{{areaData.startOfAdministrationYear + 3}}</h3>
                            <div class="overview mb-3">
                                <span class="ball-item green-ball-img">{{ countFourthYear.green }}</span>
                                <span class="ball-item yellow-ball-img">{{ countFourthYear.yellow }}</span>
                                <span class="ball-item red-ball-img">{{ countFourthYear.red }}</span>
                                <span class="ball-item gray-ball-img">{{ countFourthYear.gray }}</span>
                            </div>
                        </div>

                        <div class="legend mt-3 d-flex flex-wrap justify-content-start gap-3">
                            <div class="d-flex align-items-center legend-item">
                                <span class="green-legend me-2"></span>
                                <p class="mb-0">Alcançado</p>
                            </div>

                            <div class="d-flex align-items-center legend-item">
                                <span class="yellow-legend me-2"></span>
                                <p class="mb-0">Parcialmente Alcançado</p>
                            </div>

                            <div class="d-flex align-items-center legend-item">
                                <span class="red-legend me-2"></span>
                                <p class="mb-0">Não Alcançado</p>
                            </div>

                            <div class="d-flex align-items-center legend-item">
                                <span class="grey-legend me-2"></span>
                                <p class="mb-0">Não foi possível mensurar</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 p-3">
                <ng-container *ngFor="let challenge of areaData.challenge; index as i">
                    <div
                        class="card shadow mb-3"
                        style="cursor: pointer;"
                        [routerLink]="['/challenge']"
                        [queryParams]="{ id: challenge.uuId }"
                    >
                        <div class="row">
                        <div class="col-md-12 col-xxl-7 p-3 challenge-info">
                            <div class="info-nome">
                            <span class="decoration-off" style="color: #132446;">{{ challenge.name }}</span>
                            </div>
                        </div>
                        <div class="col-md-12 col-xxl-5 p-2 card-overview-indicator">
                            <div class="overview-indicator">
                            <div class="m-auto ms-1 text-center">
                                <span class="ball-item" [ngClass]="firstYear[i]"></span>
                                {{ areaData.startOfAdministrationYear }}
                            </div>
                            <div class="m-auto ms-1 text-center">
                                <span class="ball-item" [ngClass]="secondYear[i]"></span>
                                {{ areaData.startOfAdministrationYear + 1 }}
                            </div>
                            <div class="m-auto ms-1 text-center">
                                <span class="ball-item" [ngClass]="thirdYear[i]"></span>
                                {{ areaData.startOfAdministrationYear + 2 }}
                            </div>
                            <div class="m-auto ms-1 text-center">
                                <span class="ball-item" [ngClass]="fourthYear[i]"></span>
                                {{ areaData.startOfAdministrationYear + 3 }}
                            </div>
                            <div class="m-auto ms-1 text-center">
                                <span class="blue-legend mb-2">{{ challenge.indicatorList.length }}</span>
                                {{ challenge.indicatorList.length <= 1 ? 'Indicador' : 'Indicadores' }}
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </ng-container>

               
            </div>
        </div>
    </div>
</section>
<section>
    <ng-container>
        <div class="container">
            <div class="p-5">
                <h3 class="titleArea">OBJETIVOS DE DESENVOLVIMENTO SUSTENTÁVEL (ODS)</h3>
                <p class="descriptionArea" style="color: #0098da; font-weight:600">Veja os ODS relacionados com a área estratégica e o número de indicadores atendidos</p>
                <div class="item-ods">
                    <div *ngFor="let ods of odsCounts">
                        <a [href]="'https://brasil.un.org/pt-br/sdgs/' + ods.ods" target="_blank">
                            <img 
                                 [src]="'/assets/images/ODS/ODS-' + ods.ods + '.png'"
                                 [alt]="'ODS ' + ods"
                                 class="ods-image">
                        </a> 
                        <p class="ods-text">{{ods.count}} {{ods.count === 1 ? 'Indicador' : 'Indicadores'}}</p>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</section>
<app-footer></app-footer>